'use strict';

var React = require('react');

/**
 * Hook to detect if text content is truncated within its container
 * @returns An object containing the ref to attach to the text element and whether the text is truncated
 */ const useTextTruncation = ()=>{
    const [isTextTruncated, setIsTextTruncated] = React.useState(false);
    const observer = React.useRef(null);
    const textWrapperRef = React.useCallback((node)=>{
        if (observer.current) {
            observer.current.disconnect();
        }
        if (node) {
            const checkTruncation = ()=>{
                const isTruncated = node.scrollWidth > node.clientWidth;
                setIsTextTruncated(isTruncated);
            };
            observer.current = new ResizeObserver(checkTruncation);
            observer.current.observe(node);
            checkTruncation();
        }
    }, []);
    return {
        textWrapperRef,
        isTextTruncated
    };
};

exports.useTextTruncation = useTextTruncation;
//# sourceMappingURL=useTextTruncation.cjs.map
